// extracted by mini-css-extract-plugin
export default {"box":"PregnancyAlert_box__A0wjF","title":"PregnancyAlert_title__SrzlV","text":"PregnancyAlert_text__NaQtk"};